import { render, staticRenderFns } from "./profileViewPage.vue?vue&type=template&id=374b6ace&"
import script from "./profileViewPage.vue?vue&type=script&lang=js&"
export * from "./profileViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports